import { render, staticRenderFns } from "./ClinicHealthEducationSharingWrapper.vue?vue&type=template&id=4822ded7&scoped=true"
import script from "./ClinicHealthEducationSharingWrapper.vue?vue&type=script&lang=js"
export * from "./ClinicHealthEducationSharingWrapper.vue?vue&type=script&lang=js"
import style0 from "./ClinicHealthEducationSharingWrapper.vue?vue&type=style&index=0&id=4822ded7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4822ded7",
  null
  
)

export default component.exports